/* eslint react/jsx-key: off */
import React from 'react';
import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  required,
  NumberInput,
  Toolbar,
  SaveButton,
  CardActions
} from 'react-admin';
import {withStyles} from '@material-ui/core';
import BackButton from '../common/BackButton';

export const styles = {
  name: {display: 'inline-block'},
  email: {width: 544},
  phone: {width: 544},
  first_name: {width: 400}
};

const toolbarStyles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};

const JobRequestRadiusEditToolbar = withStyles(toolbarStyles)(({...props}) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
));
const ListActions = () => (
  <CardActions>
    <BackButton />
  </CardActions>
);

const JobRequestRadiusEdit = ({classes, ...props}) => (
  <Edit title="Edit Job Request Radius" {...props} actions={<ListActions />}>
    <TabbedForm toolbar={<JobRequestRadiusEditToolbar />}>
      <FormTab label="">
        <TextInput disabled source="serviceCategoryName" />
        <TextInput disabled source="unit" />
        <NumberInput
          autoFocus
          source="distance"
          label="Distance"
          validate={required()}
          formClassName={classes.first_name}
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);

JobRequestRadiusEdit.propTypes = {};

export default withStyles(styles)(JobRequestRadiusEdit);
